import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { CustomerCredentialFormItem } from "./CustomerForm"

export const CLEAR_CUSTOMERS_DATA = "CLEAR_CUSTOMERS_DATA"

export const clearCustomersData = () => ({
    type: CLEAR_CUSTOMERS_DATA,
})

export const CLEAR_CUSTOMERS_FEEDBACK_DATA = "CLEAR_CUSTOMERS_FEEDBACK_DATA"

export const clearCustomersFeedbackData = () => ({
    type: CLEAR_CUSTOMERS_FEEDBACK_DATA,
})

export const CUSTOMER_AGENDA_MOUNTED = "CUSTOMER_AGENDA_MOUNTED"

export const customerAgendaMounted = () => ({
    type: CUSTOMER_AGENDA_MOUNTED,
})

export const EDIT_CUSTOMER_OPENED = "EDIT_CUSTOMER_OPENED"

export const editCustomerOpened = (customerId: Maybe<string>) => ({
    type: EDIT_CUSTOMER_OPENED,
    payload: {
        customerId: customerId,
    },
})

export const CUSTOMER_FORM_SUBMITTED = "customer/form/submitted"

export const customerFormSubmitted = (
    oldValue: Maybe<CustomerCredentialFormItem>,
    newValue: CustomerCredentialFormItem
) => ({
    type: CUSTOMER_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const DELETE_CUSTOMER_CLICKED = "customer/delete/clicked"

export const deleteCustomerClicked = (customerId: string) => ({
    type: DELETE_CUSTOMER_CLICKED,
    payload: {
        customerId: customerId,
    },
})

export const CLOSE_CUSTOMER_FORM_CLICKED = "customer/close/clicked"

export const closeCustomerFormClicked = () => ({
    type: CLOSE_CUSTOMER_FORM_CLICKED,
})

export const ENROLL_TO_LOYALTY_CLICKED = "customer/ENROLL_TO_LOYALTY_CLICKED"

export const enrollToLoyaltyClicked = (customerId: string, loyaltyId: string) => ({
    type: ENROLL_TO_LOYALTY_CLICKED,
    payload: {
        customerId: customerId,
        loyaltyId: loyaltyId,
    },
})

export const REMOVE_LOYALTY_CLICKED = "customer/REMOVE_LOYALTY_CLICKED"

export const removeLoyaltyClicked = (customerId: string, customerLoyaltyId: string) => ({
    type: REMOVE_LOYALTY_CLICKED,
    payload: {
        customerId: customerId,
        customerLoyaltyId: customerLoyaltyId,
    },
})
// Customers Feedback

export const CUSTOMER_FEEDBACK_AGENDA_MOUNTED = "CUSTOMER_FEEDBACK_AGENDA_MOUNTED"

export const customerFeedbackAgendaMounted = () => {
    return {
        type: CUSTOMER_FEEDBACK_AGENDA_MOUNTED,
    }
}

export const GOOGLE_REVIEWS_AGENDA_MOUNTED = "GOOGLE_REVIEWS_AGENDA_MOUNTED"

export const googleReviewsAgendaMounted = () => ({
    type: GOOGLE_REVIEWS_AGENDA_MOUNTED,
})
